<template>
  <AppHome>
    <div slot="main">
      <section class="section">
        <List>
          <ListItemWithIcon slot="list-item" icon-position="right">
            <img slot="list-item-icon" src="~assets/images/icons/homes/gift.png">
            <div slot="list-item-text">
              <span :style="styleColorfuchsia">
                Des produits remboursés
              </span>
              <br>
              toute l'année grâce aux points de ma carte de fidélité {{ programName }} !
            </div>
          </ListItemWithIcon>
          <ListItemWithIcon slot="list-item" icon-position="left" text-align="right">
            <img slot="list-item-icon" src="~assets/images/icons/homes/camera.png">
            <div slot="list-item-text">
              <span :style="styleColorfuchsia">
                1 € = 2 points
              </span>
              <br>
              Photographiez vos tickets de caisse pour cumuler des points !
            </div>
          </ListItemWithIcon>
          <ListItemWithIcon slot="list-item" icon-position="right">
            <img slot="list-item-icon" src="~assets/images/icons/homes/receipt.png">
            <div slot="list-item-text">
              <span :style="styleColorfuchsia">
                Téléchargez vos tickets de caisse
              </span>
              <br>
              directement depuis cet espace
            </div>
          </ListItemWithIcon>
          <TheHomeDisclaimerAndros
            v-if="isAndros"
            slot="list-item"
            :emphasis-style="styleColorfuchsia"
          />
        </List>
      </section>
    </div>

    <AppFooter
      v-if="isSubscriptionDisabled"
      slot="footer"
      hide-bottom
    >
      <div slot="above-footer">
        Vous avez la carte {{ programName }} ?
        <a href="#" :style="styleColorfuchsia" @click.prevent="trackAndGoToLogin">
          Connectez-vous
        </a>
      </div>
    </AppFooter>
    <AppFooter
      v-else
      slot="footer"
      button-text="Je m'inscris à la carte"
      button-text-bold
      above-button-text="Inscription gratuite"
      above-button-italic
      @button-click="trackAndGoToSignup"
    >
      <div slot="above-footer">
        Déjà un compte FidMarques ?
        <a href="#" :style="styleColorfuchsia" @click.prevent="trackAndGoToLogin">
          Connectez-vous
        </a>
      </div>
    </AppFooter>
  </AppHome>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import AppHome   from '~/components/layout/Home'
import AppFooter from '~/components/layout/Footer'
import List              from '~/components/elements/List'
import ListItemWithIcon  from '~/components/elements/ListItemWithIcon'
import TheHomeDisclaimerAndros from '~/components/shared/TheHomeDisclaimerAndros'

import MixinPaletteFidmarques from '~/mixins/paletteFidmarques'

export default {
  components: {
    AppHome,
    AppFooter,
    List,
    ListItemWithIcon,
    TheHomeDisclaimerAndros,
  },
  mixins: [MixinPaletteFidmarques],
  computed: {
    ...mapState('server', ['programName']),
    ...mapGetters('server', ['isAndros', 'isSubscriptionDisabled']),
  },
  methods: {
    trackAndGoToSignup () {
      if (process.client) {
        ga('send', 'event', 'button', 'click', 'signup')
      }

      this.$router.push({ path: '/auth/signup' })
    },
    trackAndGoToLogin () {
      if (process.client) {
        ga('send', 'event', 'button', 'click', 'login')
      }

      this.$router.push({ path: '/auth/login' })
    },
  },
}
</script>
